import { CompanyRole, BidRequestStatus, BID_REQUEST_STATUS_ENUM } from "interfaces";

export const STATUS_FILTERS_MAPPING: Record<CompanyRole, BidRequestStatus[]> = {
  OPERATOR: [
    BID_REQUEST_STATUS_ENUM.DRAFT,
    BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED,
    BID_REQUEST_STATUS_ENUM.NEW,
    BID_REQUEST_STATUS_ENUM.FUNDED,
    BID_REQUEST_STATUS_ENUM.AML_FAILED,
    BID_REQUEST_STATUS_ENUM.CANCELED,
    BID_REQUEST_STATUS_ENUM.DRAFT_DECLINED,
  ],
  CUSTOMER: [
    BID_REQUEST_STATUS_ENUM.DRAFT_DECLINED,
    BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
    BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED,
    BID_REQUEST_STATUS_ENUM.FUNDING,
    BID_REQUEST_STATUS_ENUM.NEW,
  ],
  LIQUIDITY_PROVIDER: [BID_REQUEST_STATUS_ENUM.NEW, BID_REQUEST_STATUS_ENUM.FUNDING],
};

export const STATUS_FILTERS_TOOLTIP: Record<CompanyRole, Partial<Record<BidRequestStatus, string>>> = {
  OPERATOR: {
    [BID_REQUEST_STATUS_ENUM.DRAFT]:
      "Заявки, требующие проверки оператором корректности введенных пользователем данных, а также предложения агентских условий (при необходимости)",
    [BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED]:
      "Заявки, требующие проверки подписанных со стороны пользователя агентских документов (договор и поручение)",
    [BID_REQUEST_STATUS_ENUM.NEW]:
      "Заявки, к которым требуется предложить котировку на покупку/продажу ЦВ. После предложения котировки платформа отобразит ее клиенту для утверждения",
    [BID_REQUEST_STATUS_ENUM.FUNDED]: "Заявки, требующие подтверждения поступления д/с на р/с платформы",
    [BID_REQUEST_STATUS_ENUM.AML_FAILED]:
      "Заявки, требующие вмешательства комплаенс-офицера, так как ЦВ не прошла AML-проверку",
    [BID_REQUEST_STATUS_ENUM.CANCELED]: "Заявки, требующие возврата ЦВ отправителю",
    [BID_REQUEST_STATUS_ENUM.DRAFT_DECLINED]:
      "Заявки, требующие ознакомления с комментариями оператора, актуализации данных и повторного направления на рассмотрение",
  },
  CUSTOMER: {
    [BID_REQUEST_STATUS_ENUM.DRAFT_DECLINED]:
      "Заявки, требующие ознакомления с комментариями оператора, актуализации данных и повторного направления на рассмотрение",
    [BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL]:
      "Заявки, требующие подписания набора агентских документов (агентского поручения и договора)",
    [BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED]:
      "Заявки, требующие утверждения предложенной вам котировки на покупку/продажу ЦВ",
    [BID_REQUEST_STATUS_ENUM.FUNDING]: "Заявки, требующие перевода средств",
  },
  LIQUIDITY_PROVIDER: {
    [BID_REQUEST_STATUS_ENUM.NEW]:
      "Заявки, к которым требуется предложить котировку на покупку/продажу ЦВ. После предложения котировки платформа отобразит ее клиенту для утверждения",
    [BID_REQUEST_STATUS_ENUM.FUNDING]: "Заявки, требующие перевода средств",
  },
};
